const request = require('superagent');

const ConfigsAPI = {
    getConfigs: () => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/version`)
        .set('Accept', 'application/json')
        .send(),
};

export default ConfigsAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/configs.js
 **/